import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Sidebar from '../Sidebar';
import Header from './Header';

import ContentStyles from './Content.module.css';
// import SideNavigationStyles from '../Sidebar/Sidebar.module.css';

const Content = ({
	currentMenu,
	headerTitle,
	children,
	selectBox,
	selectBoxValue,
	selectOnchange,
	options,
	searchBox,
	searchIcon,
	searchPlaceholder,
	searchValue,
	searchOnChange,
	addBtn,
	addOnClick
}) => {
	const [ todaysDate, setTodaysDate ] = React.useState('');
	const [ chevIconRight, setChevIconRight ] = React.useState(false);

	const toggleMenu = () => {
		let navigation = document.querySelector('.navigation');
		let mainContent = document.querySelector(`.${ContentStyles.content}`);
		navigation.classList.toggle('active');
		mainContent.classList.toggle(`${ContentStyles.content_active}`);

		setChevIconRight(!chevIconRight);
	};

	const navigate = useNavigate();
	const userLogin = useSelector((state) => state.userLogin);

	React.useEffect(
		() => {
			if (
				!(
					userLogin &&
					userLogin.userInfo &&
					userLogin.userInfo.session &&
					userLogin.userInfo.session &&
					userLogin.userInfo.session.loggedin
				)
			) {
				navigate('/login');
			}
		},
		[ userLogin, navigate ]
	);

	React.useEffect(() => {
		window.setInterval(function() {
			setTodaysDate(new Date(Date.now()).toISOString());
		}, 1000);
	}, []);

	return (
		<main className={ContentStyles.container}>
			<Sidebar currentMenu={currentMenu} />

			<div className={ContentStyles.content}>
				<Header
					todaysDate={todaysDate}
					headerTitle={headerTitle}
					selectBox={selectBox}
					selectBoxValue={selectBoxValue}
					selectOnchange={selectOnchange}
					options={options}
					searchBox={searchBox}
					searchIcon={searchIcon}
					searchPlaceholder={searchPlaceholder}
					searchValue={searchValue}
					searchOnChange={searchOnChange}
					addBtn={addBtn}
					addOnClick={addOnClick}
				/>
				<button className={ContentStyles.navigation_back_btn} onClick={toggleMenu} data-testid='toggle-button'>
					<svg className={ContentStyles.navigation_back_btn_icon}>
						<use
							xlinkHref={`/assets/sprite.svg#icon-chevron-${chevIconRight ? 'right' : 'left'}`}
							data-testid='toggle-button-svg'
						/>
					</svg>
				</button>
				<div className={ContentStyles.contentData}>{children}</div>
				{/* {todaysDate !== '' && (
					<div style={{ marginTop: '1rem' }} data-testid='show-todays-date'>
						<p className={ContentStyles.todaysDate}>
							{new Date(todaysDate).getUTCHours() +
								':' +
								new Date(todaysDate).getUTCMinutes() +
								':' +
								new Date(todaysDate).getUTCSeconds() +
								' UTC'}
						</p>
						<p className={ContentStyles.todaysDate}>{todaysDate.split('T')[0]}</p>
					</div>
				)} */}
			</div>
		</main>
	);
};

export default Content;
